import { render, staticRenderFns } from "./GestioneConTe.vue?vue&type=template&id=1207b8ca&"
import script from "./GestioneConTe.vue?vue&type=script&lang=js&"
export * from "./GestioneConTe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports